import { render, staticRenderFns } from "./DBuyReport.vue?vue&type=template&id=f6ce9d1e&"
import script from "./DBuyReport.vue?vue&type=script&lang=js&"
export * from "./DBuyReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports